import { FC, ChangeEvent } from 'react';
import Image from 'next/image';

import Text from '@/components/Text';
import { blockInvalidChar } from '@/utils/helper';
import TextField, { FormPropTypes } from './TextField';
import IndiaFlag from '../../../public/vectors/india-flag.svg';

type PropTypes = FormPropTypes & {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const MobileNumberField: FC<PropTypes> = ({
  register,
  error,
  autoFocus = true,
  disabled = false,
  id = 'mobilenumber',
  onChange,
}) => {
  return (
    <TextField
      register={register}
      error={error}
      id={id}
      type='number'
      maxLength={10}
      autoFocus={autoFocus}
      placeholder='Enter Your Phone Number'
      inputClassName='pl-18 focus:border-[#38373A]'
      onKeyDown={blockInvalidChar}
      disabled={disabled}
      onChange={onChange}
      startAdornment={
        <div
          className='no-arrow-input absolute left-0 top-2/4 flex -translate-y-2/4 items-center px-3'
          aria-label='flag'>
          <Image src={IndiaFlag} alt='Mobile Number' />
          <Text className='ml-2 p-0 text-gray-500/80'>+ 91</Text>
        </div>
      }
    />
  );
};

export default MobileNumberField;
